import { AccountCircle, MoreVert } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { Modal } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Switch from '@mui/material/Switch';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../common/hooks';
import { RootState } from '../../common/Store';
import { useConstructor } from '../../common/UseConstructor';
import { changeTheme, toggleSideMenu } from '../../redux/SideNavBarSlice';
import { getUserPreferences, logout } from '../../services/AuthService';
import { UserPreferences, UserPreferencesHandle } from '../trading-system/users/UserPreferences';
import { UserPreference } from '../trading-system/users/UserAccessories';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		grow: {
			flexGrow: 1,
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		title: {
			display: 'none',
			[theme.breakpoints.up('sm')]: {
				display: 'block',
			},
		},
		search: {
			position: 'relative',
			borderRadius: theme.shape.borderRadius,
			backgroundColor: alpha(theme.palette.common.white, 0.15),
			'&:hover': {
				backgroundColor: alpha(theme.palette.common.white, 0.25),
			},
			marginRight: theme.spacing(2),
			marginLeft: 0,
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(3),
				width: 'auto',
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: '100%',
			position: 'absolute',
			pointerEvents: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		inputRoot: {
			color: 'inherit',
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)})`,
			transition: theme.transitions.create('width'),
			width: '100%',
			[theme.breakpoints.up('md')]: {
				width: '20ch',
			},
		},
		sectionDesktop: {
			display: 'none',
			[theme.breakpoints.up('md')]: {
				display: 'flex',
			},
		},
		sectionMobile: {
			display: 'flex',
			[theme.breakpoints.up('md')]: {
				display: 'none',
			},
		},
		appBar: {
			zIndex: theme.zIndex.drawer + 1,
			transition: theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
		},
		appBarShift: {
			marginLeft: drawerWidth,
			width: `calc(100% - ${drawerWidth}px)`,
			transition: theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen,
			}),
		},
		comms: {
			width: 250,
		},
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		modalPaper: {
			position: 'absolute',
			width: '80vw',
			height: '80vh',
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			overflowY: 'auto'
		}
	}),
);

export default function TopNav() {
	const navigate = useNavigate();
	const location = useLocation();
	const classes = useStyles();
	
	//Redux stuff
	const isDark = useAppSelector((state: RootState) => state.menuToggle.darkMode);
	const isDebug = useAppSelector((state: RootState) => state.menuToggle.debugMode);
	const dispatch = useAppDispatch();

	//Anchors for displaying menus
	const [profileAnchorEl, setProfileAnchorEl] = React.useState<null | HTMLElement>(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);

	//Comms section
	const isMenuOpen = Boolean(profileAnchorEl);
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

	//Close both menus
	const handleMenuClose = () => {
		setProfileAnchorEl(null);
		setMobileMoreAnchorEl(null);
	};

	const singleModalRef = React.useRef<UserPreferencesHandle>(null);
	
	//On first load of top nav, load the comms - TODO: Add timer so we constantly refresh the comms

	useConstructor(() => Initialise())
    function Initialise() {
	}

	//Main profile menu
	const menuId = 'profile-menu';
	const profileMenu = (
		<Menu
			anchorEl={profileAnchorEl}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={menuId}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isMenuOpen}
			onClose={handleMenuClose}
		>
			<MenuItem>
				<FormControlLabel
					control={<Switch checked={isDark} onChange={() => dispatch(changeTheme())} name="darkmode" />}
					label="Dark Mode"
				/>
			</MenuItem>
			<Divider />
			<MenuItem onClick={ () => {
					handleMenuClose();
					OpenUserPreferences();
				}}>Preferences</MenuItem>
			<Divider />
			<MenuItem onClick={() => {
				handleMenuClose();
				logout();
				navigate("/Login");
			}}>
				Log Out
			</MenuItem>

		</Menu>
	);


	const mobileMenuId = 'mobile-menu';
	const mobileMenu = (
		<Menu
			anchorEl={mobileMoreAnchorEl}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={mobileMenuId}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isMobileMenuOpen}
			onClose={() => setMobileMoreAnchorEl(null)}
		>
			<MenuItem>
				<FormControlLabel
					control={<Switch checked={isDark} onChange={() => dispatch(changeTheme())} name="darkmode" />}
					label="Dark Mode"
				/>
			</MenuItem>

			<Divider />
			<MenuItem onClick={() => {
					setMobileMoreAnchorEl(null);
					OpenUserPreferences();
				}}>Preferences</MenuItem>
			<Divider />
			<MenuItem onClick={() => {
				setMobileMoreAnchorEl(null);
				logout();
				navigate("/Login");
			}}>
				Log Out
			</MenuItem>
		</Menu>
	);

	function GetPageTitle(path: string)
	{
		let suffix = "";
		switch(path)
		{
			case "quotation":
				suffix = " > " + "Quotation";
				break;
			case "purchaseOrder":
				suffix = " > " + "Purchase Order";
				break;
			case "invoice":
				suffix = " > " + "Invoice";
				break;
			case "packingList":
				suffix = " > " + "Packing List";
				break;
			case "bankAccounts":
				suffix = " > " + "Bank Account";
				break;
			case "statementRecords":
				suffix = " > " + "Statement Record";
				break;
			case "statements":
				suffix = " > " + "Statement";
				break;
			case "exchangeRates":
				suffix = " > " + "Exchange Rate";
				break;
			case "customers":
				suffix = " > " + "Customer Management";
				break;		
			case "products":
				suffix = " > " + "Product Management";
				break;		
			case "productPackages":
				suffix = " > " + "Product Package";
				break;		
			case "endUsers":
				suffix = " > " + "End User Management";
				break;		
			case "deliveryMethods":
				suffix = " > " + "Delivery Method";
				break;		
			case "paymentTerms":
				suffix = " > " + "Payment Term";
				break;		
			case "customerEnvelops":
				suffix = " > " + "Print Envelop";
				break;				
			case "manufacturers":
				suffix = " > " + "Manufacturer Management";
				break;				
			case "boxSizes":
				suffix = " > " + "Box Size";
				break;				
			case "staffs":
				suffix = " > " + "Staff Management";
				break;				
			case "staffPermissions":
				suffix = " > " + "Staff Permission";
				break;				
			case "permissions":
				suffix = " > " + "Permission";
				break;				
			case "branches":
				suffix = " > " + "Branch Management";
				break;				
			case "purchaseorderHistory":
				suffix = " > " + "Trading Sales History";
				break;				
																								
			default:
		}
		return "HS2" + suffix;		
	}

    function OpenUserPreferences() {
		singleModalRef.current?.Initialise(getUserPreferences());
	}
	  
	return (
        <div >
			<AppBar position="fixed" color="inherit"
				className={classes.appBar}
			>
				<Toolbar>
					<IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => dispatch(toggleSideMenu())}
                        size="large">
						<MenuIcon fontSize="large" />
					</IconButton>

					<Typography className={classes.title} variant="h6" noWrap>
						{GetPageTitle(location.pathname.substring(location.pathname.lastIndexOf("/")+1))}
					</Typography>


					<div className={classes.grow} />


					<div className={classes.sectionDesktop}>
						<IconButton
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={(e) => setProfileAnchorEl(e.currentTarget)}
                            color="inherit"
                            size="large">
							<AccountCircle fontSize="large" />
						</IconButton>
					</div>

					<div className={classes.sectionMobile}>
						<IconButton
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={(e) => setMobileMoreAnchorEl(e.currentTarget)}
                            color="inherit"
                            size="large">
							<MoreVert fontSize="large" />
						</IconButton>
					</div>

				</Toolbar>

			</AppBar>

			{mobileMenu}
			{profileMenu}

			<UserPreferences
				ref={singleModalRef}
				onClose={handleMenuClose}
			/>
		</div>
    );
}
